/* eslint-disable */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

const PinInput = ({ onChange }) => {
  const [value, setValue] = useState("");
  const [eye, setEye] = useState(false);

  // Function to handle value change when a key is pressed
  const onChangeValue = (val) => {
    if (value.length === 6) {
      return false;
    }
    const newValue = `${value}${val}`;
    setValue(newValue);
    onChange(newValue);
    return false;
  };

  const onClearLast = () => {
    const newValue = value.substr(0, value.length - 1);
    setValue(newValue);
    onChange(newValue);
  };

  const toggleEye = () => {
    setEye(!eye);
  };

  const onClear = () => {
    setValue("");
    onChange("");
  };

  // Handle keyboard events
  const handleKeyDown = (e) => {
    const key = e.key;

    // Allow only digits (0-9)
    if (/^\d$/.test(key)) {
      onChangeValue(key);
    }

    // Handle backspace for deleting the last digit
    if (key === "Backspace") {
      onClearLast();
    }
  };

  // Attach event listener when component mounts
  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [value]); // dependency on value to ensure updated value is processed

  return (
    <div className="container" style={{ padding: "5px" }}>
      <div className="row">
        <div className="col pin-inner">
          <h1
            style={{ letterSpacing: 3, fontSize: 50, color: "rgb(30, 41, 59)" }}
            className="text-primaryh-min-100"
          >
            {value
              ? eye
                ? value
                : value
                    .replace(/\d/, "*")
                    .replace(/\d/, "*")
                    .replace(/\d/, "*")
                    .replace(/\d/, "*")
                    .replace(/\d/, "*")
                    .replace(/\d/, "*")
              : "______"}
          </h1>
          <button
            onClick={toggleEye}
            type="button"
            style={{ backgroundColor: "rgb(30, 41, 59)" }}
            className="btn btn-primary btn-sm"
          >
            {eye ? (
              <>
                <i className="far fa-eye-slash" />
              </>
            ) : (
              <>
                <i className="far fa-eye" />
              </>
            )}
          </button>
        </div>
      </div>

      <div className="row">
        {[7, 8, 9].map((num) => (
          <div className="col text-center px-2 py-2" key={num}>
            <button
              onClick={() => onChangeValue(num)}
              type="button"
              className="btn btl-lg btn-outline-primary w-100 h-100 font-weight-bold"
            >
              {num}
            </button>
          </div>
        ))}
      </div>

      <div className="row">
        {[4, 5, 6].map((num) => (
          <div className="col text-center px-2 py-2" key={num}>
            <button
              onClick={() => onChangeValue(num)}
              type="button"
              className="btn btl-lg btn-outline-primary w-100 h-100 font-weight-bold"
            >
              {num}
            </button>
          </div>
        ))}
      </div>

      <div className="row">
        {[1, 2, 3].map((num) => (
          <div className="col text-center px-2 py-2" key={num}>
            <button
              onClick={() => onChangeValue(num)}
              type="button"
              className="btn btl-lg btn-outline-primary w-100 h-100 font-weight-bold"
            >
              {num}
            </button>
          </div>
        ))}
      </div>

      <div className="row">
        <div className="col text-center px-2 py-2">
          <button
            onClick={onClear}
            type="button"
            className="btn btl-lg btn-outline-danger w-100 h-100"
          >
            Reset
          </button>
        </div>
        <div className="col text-center px-2 py-2">
          <button
            onClick={() => onChangeValue(0)}
            type="button"
            className="btn btl-lg btn-outline-primary w-100 h-100 font-weight-bold"
          >
            0
          </button>
        </div>
        <div className="col text-center px-2 py-2">
          <button
            onClick={onClearLast}
            type="button"
            className="btn btl-lg btn-outline-danger w-100 h-100"
          >{`<`}</button>
        </div>
      </div>
    </div>
  );
};

PinInput.defaultProps = {};

PinInput.propTypes = {
  onChange: PropTypes.instanceOf(Function).isRequired,
};

export default PinInput;
